module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p16-17.e7b451cf.jpg";